import { type ReactNode } from 'react';

import { type Feature, isFeatureAvailable } from '../shared/feature';

export function FeatureFlag(props: { children: ReactNode; flags: Feature[] | Feature }) {
  const features = Array.isArray(props.flags) ? props.flags : [props.flags];
  const shouldRenderChildren = features.reduce(
    (prev, curr) => prev && isFeatureAvailable(curr),
    true
  );
  if (!shouldRenderChildren) {
    return null;
  }
  return props.children;
}
